import React from 'react';
import { useGame } from '../context/GameContext';
import GameCard from '../components/GameCard';
import { ArrowLeft, Trash2 } from 'lucide-react';

export default function CardRemove() {
  const { run, confirmRemoveCard, cancelRemoveCard, pendingShop } = useGame();
  if (!run) return null;
  const price = pendingShop?.removePrice ?? 0;
  return (
    <div className="min-h-screen w-full px-6 py-6">
      <div className="flex items-center justify-between">
        <button className="brutal-btn text-sm" onClick={cancelRemoveCard} data-testid="remove-back-button">
          <ArrowLeft size={16} /> BACK
        </button>
        <h1 className="font-display text-4xl sm:text-5xl font-black uppercase text-[color:var(--red)] flex items-center gap-3">
          <Trash2 /> DELETE A CARD
        </h1>
        <div className="text-sm font-mono uppercase text-[color:var(--text-dim)]">costs {price}G · gold: <span className="text-[color:var(--neon)]">{run.player.gold}</span></div>
      </div>
      <div className="mt-4 text-center text-sm uppercase tracking-widest text-[color:var(--text-dim)]">
        pick one to yeet from your deck forever
      </div>

      <div className="mt-10 flex flex-wrap gap-4 justify-center" data-testid="remove-cards-list">
        {run.player.deck.map((cid, i) => (
          <div key={i} onClick={() => confirmRemoveCard(i)} className="cursor-pointer hover:scale-105 transition-transform">
            <GameCard cardId={cid} testid={`remove-slot-${i}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
